import IInputFile from "./interfaces/IInputFile";
import IAppState from "../../IAppState";
import ISummaryState from "./interfaces/ISummaryState";

// Function in this file helps to convert data structures
// used in application state to data structures used in saved file

const identity = (value: any) => value;

export const allToFile = (appState: IAppState): IInputFile => {
    const sumSt: ISummaryState = appState.summaryState;
    return {
        jobTitle: appState.mainState.jobTitle,
        
    };
};
